
const handleCompanySelection = () => {
    const companySelectionButton = document.querySelector('.s-company-selection #company-selection-button');
    const companySelectionSelect = document.querySelector('.s-company-selection #company-selection-select');

    if (companySelectionButton) {
        companySelectionButton.addEventListener('click', () => {
            const linkValue = companySelectionSelect.value;
            window.location.href = linkValue;
        });
    }
};

document.addEventListener('DOMContentLoaded', handleCompanySelection);
